import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import AppIcon from 'modules/app_store/components/AppIcon'
import CTAButton from 'modules/app_store/components/CTAButton'
import ContactLink from 'modules/app_store/components/ContactLink'
import HelpLink from 'modules/app_store/components/HelpLink'
import { type Types, getApplicationLabels } from 'modules/app_store/lib/getApplicationLabels'
import subscriptionAddons from 'modules/billing/store/collections/subscriptionAddons'
import { JOB_BOARD_INTEGRATIONS } from 'modules/billing/store/collections/subscriptionAddons'
import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

interface Props {
  subscriptionAddon: SubscriptionAddon
}

const Sidebar = ({ subscriptionAddon }: Props) => {
  const id = subscriptionAddon.attributes.id

  const atsInactive = !subscriptionAddons.find({
    id: 'ats',
  })?.attributes.enabled

  const hasIntegrationText = (): boolean => {
    if (JOB_BOARD_INTEGRATIONS.includes(id) && atsInactive) return false

    switch (id) {
      case 'payroll_bundle':
      case 'document_templates':
      case 'expenses_v2':
      case 'performance_v2':
      case 'surveys':
      case 'goals':
      case 'competencies':
      case 'trainings_custom_table':
        return false
      default:
        return true
    }
  }

  // FIXME: sorry for this any, but we arrived late to the party
  const { title, description } = getApplicationLabels(subscriptionAddon.type as Types, id)

  return (
    <Box gap="s32">
      <AppIcon size="64" id={id} isVerified={subscriptionAddon.isApp} />
      <Box gap="s8">
        <Text.Header2>{title}</Text.Header2>
        <Text.Normal>{description}</Text.Normal>
        <CTAButton subscriptionAddon={subscriptionAddon} />
        {hasIntegrationText() && (
          <Text size="200" color="grey800">
            {i18n.t('app_store_v2.common.app_cost.integration')}
          </Text>
        )}
        <ContactLink subscriptionAddon={subscriptionAddon} />
        <HelpLink subscriptionAddon={subscriptionAddon} />
      </Box>
    </Box>
  )
}

export default Sidebar
